import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { LeadSection } from '../components/LeadSection';
import { SymptomSection } from '../components/SymptomSection';
import { FuturePacingSection } from '../components/FuturePacingSection';
import { MechanismSection } from '../components/MechanismSection';
import { TestimonialSection } from '../components/TestimonialSection';
import { MainIngredientSection } from '../components/MainIngredientSection';
import { ProductRevealSection } from '../components/ProductRevealSection';
export function Advertorial() {
  useEffect(() => {
    // Taboola Pixel
    ;
    (window as any)._tfa = (window as any)._tfa || [];
    (window as any)._tfa.push({
      notify: 'event',
      name: 'page_view',
      id: 2020143
    });
    if (!document.getElementById('tb_tfa_script')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = '//cdn.taboola.com/libtrc/unip/2020143/tfa.js';
      script.id = 'tb_tfa_script';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
    // Google Analytics (gtag.js)
    // Google Analytics (gtag.js)
    ;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).gtag = function () {
      ;
      (window as any).dataLayer.push(arguments);
    };
    (window as any).gtag('js', new Date());
    (window as any).gtag('config', 'G-TEW0MBTC4Q');
    if (!document.getElementById('ga_gtag_script')) {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-TEW0MBTC4Q';
      gtagScript.id = 'ga_gtag_script';
      document.head.appendChild(gtagScript);
    }
    // Microsoft Clarity Heatmap
    ;
    (window as any).clarity = (window as any).clarity || function (...args: any[]) {
      ;
      ((window as any).clarity.q = (window as any).clarity.q || []).push(args);
    };
    if (!document.getElementById('clarity_script')) {
      const clarityScript = document.createElement('script');
      clarityScript.async = true;
      clarityScript.src = 'https://www.clarity.ms/tag/w6kvdka9az';
      clarityScript.id = 'clarity_script';
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(clarityScript, firstScript);
    }
    // Taboola Click ID (tblci) passthrough to CTA links
    const urlParams = new URLSearchParams(window.location.search);
    const tblci = urlParams.get('tblci');
    if (tblci) {
      document.querySelectorAll('a[href*="tryclearguard.com"]').forEach(link => {
        const url = new URL((link as HTMLAnchorElement).href);
        url.searchParams.set('tblci', tblci);
        (link as HTMLAnchorElement).href = url.toString();
      });
    }
    // Taboola CTA click tracking
    document.querySelectorAll('a[href*="tryclearguard.com"]').forEach(link => {
      link.addEventListener('click', () => {
        ;
        (window as any)._tfa = (window as any)._tfa || [];
        (window as any)._tfa.push({
          notify: 'event',
          name: 'ADV_CLICK_TO_SALES_PAGE',
          id: 2020143
        });
      });
    });
  }, []);
  return <div className="min-h-screen flex flex-col bg-stone-50" data-id="element-535">
      <Header data-id="element-536" />

      <main className="flex-grow px-4 md:px-6" data-id="element-537">
        <article className="pb-8" data-id="element-538">
          <LeadSection data-id="element-539" />
          <SymptomSection data-id="element-540" />
          <FuturePacingSection data-id="element-541" />
          <MechanismSection data-id="element-542" />
          <TestimonialSection data-id="element-543" />
          <MainIngredientSection data-id="element-544" />
          <ProductRevealSection data-id="element-545" />
        </article>
      </main>

      <Footer data-id="element-546" />
    </div>;
}